import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { withStyles } from '@material-ui/core/styles';
import GlobalVariables from '../../GlobalVariables';

const styles = theme => ({
  root: {
    display: 'flex',
  },
  paper: {
    marginRight: theme.spacing.unit * 2,
  },
});

class MenuListComposition extends React.Component {
  state = {
    open: false,
    currentLang: 'tc',
    currentPagepath: ''
  };

  static contextTypes = {
    router: PropTypes.shape({
        history: PropTypes.shape({
            push: PropTypes.func.isRequired,
            replace: PropTypes.func.isRequired
        }).isRequired,
        staticContext: PropTypes.object
    }).isRequired
  };

  componentDidMount() {
      this.props.provideInstance({
          updatePathsByParent: (globalVariable, currentProps) => this.updatePaths(globalVariable, currentProps)
      });
  }

  componentWillUnmount() {
      this.props.provide
  }

  handleToggle = () => {
    this.setState(state => ({ open: !state.open }));
  };

  handleClose = event => {
    //console.log("HeaderLanguageButtons, handleClose()");
    //console.log(event.target);
    //console.log(event.target.className);
    let toLang = null;

    if(event.target.className.indexOf("switch-language-btns") !== -1){
        //console.log(event.target.attributes.getNamedItem('data-tolang').value);
        toLang = event.target.attributes.getNamedItem('data-tolang').value;
    }
    

    if (this.anchorEl.contains(event.target)) {
      return;
    }

    this.setState({ open: false });

    if(toLang !== null && toLang !== this.state.currentLang){
        //console.log("currentLang: ", this.state.currentLang);
        //console.log("current path: ", this.state.currentPagepath, "; will route to: /", toLang, "/...");
        
        let path = (toLang === 'tc') ? this.state.currentPagepath : '/' + toLang + this.state.currentPagepath;
        //console.log("path: ", path);
        //console.log(this.context.router);
        this.context.router.history.push(path);
    }
  };

  updatePaths = (gv, cp) => {
    /*
    console.log("HeaderLanguageButtons, updatePaths()");
    console.log(gv);
    console.log(cp);
    console.log(this);
    */
    this.setState({ currentLang: gv.currentLang });
    this.setState({ currentPagepath: gv.currentPagepath });
    //console.log(this);
  };

  getLangText(langJson) {
    return (GlobalVariables.currentLang) ? langJson[GlobalVariables.currentLang] : langJson['tc'];
  }

  render() {
    const { classes } = this.props;
    const { open } = this.state;

    return (
      <div className={classes.root}>
        <div>
          <Button 
            style={{ verticalAlign:'top', minHeight:'28px', fontSize:'14px', paddingTop:'4px', paddingBottom:'4px' }}
            buttonRef={node => {
              this.anchorEl = node;
            }}
            aria-owns={open ? 'menu-list-grow' : null}
            aria-haspopup="true"
            onClick={this.handleToggle}
          >
            <span style={{textTransform:'none'}}>
              {
                this.getLangText ({
                  'tc': '語言',
                  'sc': '语言',
                  'en': 'Language'
                })
              }
            </span>
          </Button>
          <Popper open={open} anchorEl={this.anchorEl} transition disablePortal style={{ zIndex:'1001' }} >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                id="menu-list-grow"
                style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={this.handleClose}>
                    <MenuList>
                      <MenuItem className="switch-language-btns" style={{ justifyContent:'center' }} data-tolang="tc" onClick={this.handleClose}>繁</MenuItem>
                      <MenuItem className="switch-language-btns" style={{ justifyContent:'center' }} data-tolang="sc" onClick={this.handleClose}>简</MenuItem>
                      <MenuItem className="switch-language-btns" style={{ justifyContent:'center' }} data-tolang="en" onClick={this.handleClose}>ENG</MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </div>
    );
  }
}

MenuListComposition.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MenuListComposition);



// WEBPACK FOOTER //
// ./src/components/pages/includes/HeaderLanguageButtons.js